const initialState = {
    get: [],
    
  };
  
  const ASpecialityReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'fetch_GET_success':
        return { ...state, get: action.payload };
        
      
    

      default:
        return state;
    }
  };
  
  export default ASpecialityReducers;
  
  